module.exports = __webpack_public_path__ + "img/engineer.b9865b88.png";